webpackJsonp([24],{

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("3d12485e", content, true);

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, ".main-container[data-v-44d42cba]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:10px;margin-top:20px}.content[data-v-44d42cba]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.item-list-container[data-v-44d42cba]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-right:20px}.item-list[data-v-44d42cba]{list-style-type:none;padding:0;width:300px;border:1px solid #ddd;border-radius:8px;-webkit-box-shadow:0 4px 8px rgba(0,0,0,.1);box-shadow:0 4px 8px rgba(0,0,0,.1)}.item[data-v-44d42cba]{border-bottom:1px solid #ddd}.item[data-v-44d42cba]:last-child{border-bottom:none}.item-button[data-v-44d42cba]{width:100%;background-color:#909090;color:#fff;border:none;border-radius:0;padding:15px 0;cursor:pointer;text-align:left;padding-left:20px;font-size:16px;-webkit-transition:background-color .3s,color .3s;transition:background-color .3s,color .3s}.item-button[data-v-44d42cba]:hover{background-color:#6d6d6d;color:#fff}.additional-component[data-v-44d42cba]{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-right:30px;padding:20px;background-color:#f5f5f5;border-radius:8px;-webkit-box-shadow:0 4px 8px rgba(0,0,0,.1);box-shadow:0 4px 8px rgba(0,0,0,.1);height:73vh}.item-button.disabled[data-v-44d42cba]{background-color:#c7c7c7;cursor:not-allowed;pointer-events:none}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/configuration-general/page-configuration-general-v2.vue"],"names":[],"mappings":"AACA,iCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,eAAiB,CAClB,AACD,0BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,sCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,iBAAmB,CACpB,AACD,4BACE,qBAAsB,AACtB,UAAW,AACX,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,4CAAiD,AACzC,mCAAyC,CAClD,AACD,uBACE,4BAA8B,CAC/B,AACD,kCACE,kBAAoB,CACrB,AACD,8BACE,WAAY,AACZ,yBAA0B,AAC1B,WAAa,AACb,YAAa,AACb,gBAAiB,AACjB,eAAgB,AAChB,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,eAAgB,AAChB,kDAAsD,AACtD,yCAA8C,CAC/C,AACD,oCACE,yBAA0B,AAC1B,UAAY,CACb,AACD,uCACE,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,kBAAmB,AACnB,aAAc,AACd,yBAA0B,AAC1B,kBAAmB,AACnB,4CAAiD,AACzC,oCAAyC,AACjD,WAAa,CACd,AACD,uCACI,yBAA0B,AAC1B,mBAAoB,AACpB,mBAAqB,CACxB","file":"page-configuration-general-v2.vue","sourcesContent":["\n.main-container[data-v-44d42cba] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-left: 10px;\n  margin-top: 20px;\n}\n.content[data-v-44d42cba] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.item-list-container[data-v-44d42cba] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-right: 20px;\n}\n.item-list[data-v-44d42cba] {\n  list-style-type: none;\n  padding: 0;\n  width: 300px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n.item[data-v-44d42cba] {\n  border-bottom: 1px solid #ddd;\n}\n.item[data-v-44d42cba]:last-child {\n  border-bottom: none;\n}\n.item-button[data-v-44d42cba] {\n  width: 100%;\n  background-color: #909090;\n  color: white;\n  border: none;\n  border-radius: 0;\n  padding: 15px 0;\n  cursor: pointer;\n  text-align: left;\n  padding-left: 20px;\n  font-size: 16px;\n  -webkit-transition: background-color 0.3s, color 0.3s;\n  transition: background-color 0.3s, color 0.3s;\n}\n.item-button[data-v-44d42cba]:hover {\n  background-color: #6d6d6d;\n  color: #fff;\n}\n.additional-component[data-v-44d42cba] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  margin-right: 30px;\n  padding: 20px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  height: 73vh;\n}\n.item-button.disabled[data-v-44d42cba] {\n    background-color: #c7c7c7;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_employee_vue__ = __webpack_require__(837);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b109d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_employee_vue__ = __webpack_require__(1031);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_employee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b109d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_employee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs7":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","mr-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","type":"number","label":"Cantidad de Empleados","required":""},model:{value:(_vm.employeeCount),callback:function ($$v) {_vm.employeeCount=$$v},expression:"employeeCount"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1032:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_kardex_vue__ = __webpack_require__(838);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28274ed1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_kardex_vue__ = __webpack_require__(1033);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_kardex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28274ed1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_kardex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs7":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t    \t\t\tIndicar si la empresa trabajara con conversion (intercambio de documento NTV -> BOL) (flagChangeNtvFlow)\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":"Permitir intercambiar numeracion al convertir notas de venta(relacionadas a pedidos) a boleta/factura."}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex.flagChangeNtvFlow),callback:function ($$v) {_vm.$set(_vm.flagKardex, "flagChangeNtvFlow", $$v)},expression:"flagKardex.flagChangeNtvFlow"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t    \t\t\t"+_vm._s(_vm.labelShowKardex)+" (flagKardexValued)\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":"Si activo esta opción se usará el calculo de costo promedio si en caso lo desactivo\n\t\t\t\t\t\t\t\t\t\t\tel costo que se va a mostrar en tu producto maestro va hacer el último costo de tu compra."}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex.flagKardexValued),callback:function ($$v) {_vm.$set(_vm.flagKardex, "flagKardexValued", $$v)},expression:"flagKardex.flagKardexValued"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t    \t\t\tCalculo de saldo de stock y costo inmediato (flagKardexFast)\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":"Indica si el inmediatamente despues de registrar en el kardex estos registros se les calculará el stock y/o costo')."}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex.flagKardexFast),callback:function ($$v) {_vm.$set(_vm.flagKardex, "flagKardexFast", $$v)},expression:"flagKardex.flagKardexFast"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t    \t\t\t"+_vm._s(_vm.labelShowRegisterKardex)+" (typeRegisterKardex)\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":"Al habilitar este campo se genera un registro inmediato por DB, de lo contrario se registra por SQS."}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"disabled":true,"false-value":1,"true-value":2,"color":"success","hide-details":""},model:{value:(_vm.flagKardex.typeRegisterKardex),callback:function ($$v) {_vm.$set(_vm.flagKardex, "typeRegisterKardex", $$v)},expression:"flagKardex.typeRegisterKardex"}})],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_params_globales_vue__ = __webpack_require__(839);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec2d1c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_params_globales_vue__ = __webpack_require__(1037);
function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ec2d1c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_params_globales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec2d1c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_params_globales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1036);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("1d4044e6", content, true);

/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, ".scroll-container[data-v-2ec2d1c4]{max-height:60vh;overflow-y:auto}.custom-tabs .v-tab[data-v-2ec2d1c4]{background-color:transparent}.custom-tabs .v-tabs-slider[data-v-2ec2d1c4]{background-color:transparent!important}.custom-tabs[data-v-2ec2d1c4]{overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.3) transparent}.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar{height:8px}.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar-track{background:transparent;border-radius:4px}.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.3);border-radius:4px;-webkit-transition:background-color .2s;transition:background-color .2s}.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar-thumb:hover{background-color:rgba(0,0,0,.5)}.custom-tabs .v-tabs__wrapper[data-v-2ec2d1c4]{overflow-x:auto;overflow-y:hidden}.custom-tabs .v-tabs__container[data-v-2ec2d1c4]{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.tab-item[data-v-2ec2d1c4]{-ms-flex-negative:0;flex-shrink:0;white-space:nowrap;min-width:auto}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/configuration-general/configuration-params-globales.vue"],"names":[],"mappings":"AACA,mCACI,gBAAiB,AACjB,eAAiB,CACpB,AACD,qCACE,4BAA8B,CAC/B,AACD,6CACE,sCAAyC,CAC1C,AACD,8BACE,gBAAiB,AACjB,kBAAmB,AACnB,iCAAkC,AAClC,qBAAsB,AACtB,0CAAgD,CACjD,AACD,iDACE,UAAY,CACb,AACD,uDACE,uBAAwB,AACxB,iBAAmB,CACpB,AACD,uDACE,gCAAqC,AACrC,kBAAmB,AACnB,wCAA0C,AAC1C,+BAAkC,CACnC,AACD,6DACE,+BAAqC,CACtC,AACD,+CACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,iDACE,qBAAsB,AAClB,gBAAkB,CACvB,AACD,2BACE,oBAAqB,AACjB,cAAe,AACnB,mBAAoB,AACpB,cAAgB,CACjB","file":"configuration-params-globales.vue","sourcesContent":["\n.scroll-container[data-v-2ec2d1c4] {\n    max-height: 60vh;\n    overflow-y: auto;\n}\n.custom-tabs .v-tab[data-v-2ec2d1c4]{\n  background-color: transparent;\n}\n.custom-tabs .v-tabs-slider[data-v-2ec2d1c4] {\n  background-color: transparent !important;\n}\n.custom-tabs[data-v-2ec2d1c4] {\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;\n}\n.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar {\n  height: 8px;\n}\n.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 4px;\n}\n.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  -webkit-transition: background-color 0.2s;\n  transition: background-color 0.2s;\n}\n.custom-tabs[data-v-2ec2d1c4]::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.custom-tabs .v-tabs__wrapper[data-v-2ec2d1c4] {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.custom-tabs .v-tabs__container[data-v-2ec2d1c4] {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.tab-item[data-v-2ec2d1c4] {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  white-space: nowrap;\n  min-width: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1037:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{staticClass:"custom-tabs",attrs:{"slider-color":"cyan"},model:{value:(_vm.tabsModel),callback:function ($$v) {_vm.tabsModel=$$v},expression:"tabsModel"}},[_vm._l((_vm.tabs),function(tab,index){return _c('v-tab',{key:index,staticClass:"tab-item"},[_vm._v("\n\t\t\t"+_vm._s(tab.name)+"\n\t\t")])}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.flagProducts),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('p',{staticClass:"company-text-regular ma-0"},[_vm._v("Tipo de Producto:")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-checkbox',{attrs:{"color":"success","label":"Producto Terminado","value":_vm.codeProduct},model:{value:(_vm.selectTypeProducts),callback:function ($$v) {_vm.selectTypeProducts=$$v},expression:"selectTypeProducts"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-checkbox',{attrs:{"color":"success","label":"Servicio","value":_vm.codeServices},model:{value:(_vm.selectTypeProducts),callback:function ($$v) {_vm.selectTypeProducts=$$v},expression:"selectTypeProducts"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-checkbox',{attrs:{"color":"success","label":"Compuesto","value":_vm.codeComposed},model:{value:(_vm.selectTypeProducts),callback:function ($$v) {_vm.selectTypeProducts=$$v},expression:"selectTypeProducts"}})],1)],1)],1)],1)],1)],2)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagSales),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagQuotations),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagOrders),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.flaDistributions),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('p',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tForma de calcular distancia - (distanceMode)\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","ml-1":""}},[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":"Forma en la que se calculará la distancia entre el comercio y la dirección del cliente en el pedido"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"label":"","hide-details":"","item-text":"name","item-value":"id","items":_vm.typeDistanceMode},model:{value:(_vm.flagKardex.distanceMode),callback:function ($$v) {_vm.$set(_vm.flagKardex, "distanceMode", $$v)},expression:"flagKardex.distanceMode"}})],1)],1)],1)],2)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagAccounting),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagAgencyTranport),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagPointSale),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagCustomers),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagPurchases),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{staticClass:"scroll-container",attrs:{"xs9":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.flagSupport),function(flag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"company-text-regular ma-0"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(flag.name)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"help","text":flag.tooltip}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.flagKardex[flag.flag]),callback:function ($$v) {_vm.$set(_vm.flagKardex, flag.flag, $$v)},expression:"flagKardex[flag.flag]"}})],1)],1)],1)],1)],1)}))],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1038:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_subsidiary_vue__ = __webpack_require__(840);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6772ffee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_subsidiary_vue__ = __webpack_require__(1043);
function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6772ffee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_subsidiary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6772ffee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_subsidiary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1040);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("45b56985", content, true);

/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, ".pb-price[data-v-6772ffee]{border-bottom:1px solid color(border-green-light);margin:7px 0}.modal-filter[data-v-6772ffee]{position:absolute;bottom:0;width:100%}.subsidiary--name[data-v-6772ffee]{margin-left:20px}.scroll-container[data-v-6772ffee]{max-height:650px;overflow-y:auto}.btn-extra-small[data-v-6772ffee]{height:30px!important;width:30px!important}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/configuration-general/configuration-subsidiary.vue"],"names":[],"mappings":"AACA,2BACI,kDAAmD,AACtD,YAAgB,CAChB,AACD,+BACI,kBAAmB,AACnB,SAAU,AACV,UAAY,CACf,AACD,mCACI,gBAAkB,CACrB,AACD,mCACI,iBAAkB,AAClB,eAAiB,CACpB,AACD,kCACI,sBAAwB,AACxB,oBAAuB,CAC1B","file":"configuration-subsidiary.vue","sourcesContent":["\n.pb-price[data-v-6772ffee] {\t\n    border-bottom: 1px solid color(border-green-light);\n\tmargin: 7px 0px;\n}\n.modal-filter[data-v-6772ffee] {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n}\n.subsidiary--name[data-v-6772ffee] {\n    margin-left: 20px;\n}\n.scroll-container[data-v-6772ffee] {\n    max-height: 650px;\n    overflow-y: auto;\n}\n.btn-extra-small[data-v-6772ffee] {\n    height: 30px !important;\n    width: 30px !important;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ 1042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"ml-4":"","mt-3":""}},[_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs5":"","mr-5":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","solo":"","background-color":"white","hide-details":"","label":"Rol","item-text":"name","item-value":"code","return-object":"","items":_vm.roles},model:{value:(_vm.model.role),callback:function ($$v) {_vm.$set(_vm.model, "role", $$v)},expression:"model.role"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","type":"number","label":"Numero de Empleados","required":""},model:{value:(_vm.model.quantity),callback:function ($$v) {_vm.$set(_vm.model, "quantity", $$v)},expression:"model.quantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mb-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs5":"","mr-5":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre","required":""},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","multiple":"","clearable":"","hide-details":"","item-text":"name","item-value":"code","label":"Tipo de Documento","items":_vm.typeDocuments,"return-object":false},model:{value:(_vm.model.typeDocuments),callback:function ($$v) {_vm.$set(_vm.model, "typeDocuments", $$v)},expression:"model.typeDocuments"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mb-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs5":"","mr-5":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Serie","type":"number","required":""},model:{value:(_vm.model.serieInit),callback:function ($$v) {_vm.$set(_vm.model, "serieInit", $$v)},expression:"model.serieInit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","type":"number","label":"Numero inical","required":""},model:{value:(_vm.model.employeeInit),callback:function ($$v) {_vm.$set(_vm.model, "employeeInit", $$v)},expression:"model.employeeInit"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","ml-4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('p',{staticClass:"company-text-regular ma-0"},[_vm._v("Ocultar Precio de Costo:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","pl-2":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-switch',{attrs:{"color":"primary","hide-details":""},model:{value:(_vm.model.flagNotShowCostPrice),callback:function ($$v) {_vm.$set(_vm.model, "flagNotShowCostPrice", $$v)},expression:"model.flagNotShowCostPrice"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-btn',{on:{"click":_vm.addEmployee}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"ml-5":"","mr-4":"","mt-4":""}},[_c('app-table',{attrs:{"input-search":false,"include-filter":false,"columns":_vm.columns,"rows":_vm.users},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t    \t\t"+_vm._s(props.row.quantity)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.codeTypeRol)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.password)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_c('app-tooltip-button',{attrs:{"color":"red","icon":"delete","text":"Eliminar"},on:{"click-icon":function($event){_vm.deleteEmployee(props.row)}}})],1)]}}])})],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.validation},on:{"accept-button-clicked":_vm.saveData,"cancel-button-clicked":function($event){_vm.$emit('close-modal')}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1043:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"scroll-container"},[_c('v-flex',{attrs:{"xs7":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',{staticClass:"grey--text text--darken-2 caption font-weight-bold uppercase mb-1"},[_vm._v("Nro. de Sucursales")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-btn',{staticClass:"btn-extra-small elevation-1",attrs:{"fab":"","small":"","color":"white"},on:{"click":_vm.removeSubsidiary}},[_c('v-icon',{attrs:{"color":"grey darken-2","small":""}},[_vm._v("remove")])],1),_vm._v(" "),_c('span',{staticClass:"mx-3 subheading font-weight-medium grey--text text--darken-3"},[_vm._v("\n                            "+_vm._s(_vm.subsidiaries.length)+"\n                        ")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-extra-small elevation-1",attrs:{"fab":"","small":"","color":"white"},on:{"click":_vm.addSubsidiary}},[_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.subsidiaries.length > 0)?_c('v-layout',{class:_vm.subsidiaries.length > 0 ? 'pb-price' : '',attrs:{"row":"","wrap":"","mb-5":""}},_vm._l((_vm.subsidiaries),function(subs,indexSubs){return _c('v-flex',{key:indexSubs,attrs:{"xs10":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mt-4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{class:!_vm.isEdit ? 'xs3' : 'xs5',attrs:{"text-xs-center":""}},[_c('v-layout',{attrs:{"xs2":"","text-xs-center":"","pl-5":""}},[_c('v-icon',{on:{"click":_vm.editSubsidiary}},[_vm._v("edit")]),_vm._v(" "),(!_vm.isEdit)?_c('span',{staticClass:"subsidiary--name"},[_vm._v(_vm._s(subs.subsidiaryName))]):_c('v-flex',{attrs:{"xs12":"","ml-4":"","mr-4":""}},[_c('v-text-field',{attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre de Sucursal","required":""},model:{value:(subs.subsidiaryName),callback:function ($$v) {_vm.$set(subs, "subsidiaryName", $$v)},expression:"subs.subsidiaryName"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","pl-3":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',{staticClass:"grey--text text--darken-2 caption font-weight-bold uppercase mb-1"},[_vm._v("Nro. de Tiendas")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-btn',{staticClass:"btn-extra-small elevation-1",attrs:{"fab":"","small":"","color":"white"},on:{"click":function($event){_vm.removeWarehouse(indexSubs)}}},[_c('v-icon',{attrs:{"color":"grey darken-2","small":""}},[_vm._v("remove")])],1),_vm._v(" "),_c('span',{staticClass:"mx-3 subheading font-weight-medium grey--text text--darken-3"},[_vm._v("\n                                                    "+_vm._s(subs.warehouse.length)+"\n                                                ")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-extra-small elevation-1",attrs:{"fab":"","small":"","color":"white"},on:{"click":function($event){_vm.addWarehouse(indexSubs)}}},[_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("add")])],1)],1)],1)],1)],1),_vm._v(" "),(_vm.subsidiaries[indexSubs].warehouse.length > 0)?_c('v-layout',{class:_vm.subsidiaries[indexSubs].warehouse.length > 0 ? 'pb-price' : '',attrs:{"row":"","wrap":""}},_vm._l((_vm.subsidiaries[indexSubs].warehouse),function(warehouse,indexWarehouse){return _c('v-flex',{key:indexWarehouse,attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pb-3":"","ml-5":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{class:!_vm.isEditWarehouse ? 'xs3' : 'xs5',attrs:{"text-xs-center":""}},[_c('v-layout',{attrs:{"xs2":"","text-xs-center":"","pl-5":""}},[_c('v-icon',{on:{"click":_vm.editWarehouse}},[_vm._v("edit")]),_vm._v(" "),(!_vm.isEditWarehouse)?_c('span',{staticClass:"subsidiary--name",attrs:{"text-xs-start":""}},[_vm._v(_vm._s(warehouse.warehouseName))]):_c('v-flex',{attrs:{"xs12":"","ml-4":"","mr-4":""}},[_c('v-text-field',{attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre de la tienda","required":""},model:{value:(warehouse.warehouseName),callback:function ($$v) {_vm.$set(warehouse, "warehouseName", $$v)},expression:"warehouse.warehouseName"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","pl-1":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Dominio","required":""},model:{value:(warehouse.suffixDomain),callback:function ($$v) {_vm.$set(warehouse, "suffixDomain", $$v)},expression:"warehouse.suffixDomain"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2",attrs:{"xs1":""}},[_c('v-btn',{staticClass:"elevation-2",attrs:{"color":"primary","fab":"","small":""},on:{"click":function($event){_vm.asignEmployee(indexSubs, indexWarehouse)}}},[_c('v-icon',[_vm._v("person_add")])],1)],1),_vm._v(" "),(_vm.validateUser(warehouse.user))?_c('v-flex',{staticClass:"d-flex align-center justify-center",attrs:{"xs1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check")]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.validateUser(warehouse.user)))])],1)]),_vm._v(" "),_c('span',[_vm._v("Cantidad de empleados: "+_vm._s(_vm.validateUser(warehouse.user)))])],2)],1):_vm._e()],1)],1)],1)],1)})):_vm._e()],1)],1)],1)})):_vm._e()],1)],1),_vm._v(" "),_c('action-sidebar',{attrs:{"title":_vm.action.title,"width":_vm.action.width,"value":_vm.action.open},on:{"close-modal":_vm.closeModal}},[(_vm.action.code === 'AE')?_c('asign-employee',{attrs:{"code-project":_vm.codeProject,"users-exist":_vm.users,"id-template":Number(_vm.idTemplate)},on:{"save-data":_vm.saveUsers,"close-modal":_vm.closeModal}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_payment_methods_vue__ = __webpack_require__(843);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7974f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_payment_methods_vue__ = __webpack_require__(1047);
function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f7974f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_payment_methods_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7974f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_payment_methods_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1046);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("56262d58", content, true);

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "span[data-v-0f7974f0]{font-size:15px!important}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/configuration-general/configuration-payment-methods.vue"],"names":[],"mappings":"AACA,sBACC,wBAA2B,CAC3B","file":"configuration-payment-methods.vue","sourcesContent":["\nspan[data-v-0f7974f0] {\n\tfont-size: 15px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs7":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('span',{staticClass:"grey--text text--darken-2 caption font-weight-bold uppercase mb-1"},[_vm._v("Compras")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","multiple":"","chips":"","deletable-chips":"","clearable":"","hide-details":"","item-text":"name","item-value":"id","label":"Tipo de Pago para Compras","items":_vm.typePaymentMethods},on:{"change":function($event){_vm.emitChange('codePurchase', $event)}},model:{value:(_vm.typePaymentPurchases),callback:function ($$v) {_vm.typePaymentPurchases=$$v},expression:"typePaymentPurchases"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('span',{staticClass:"grey--text text--darken-2 caption font-weight-bold uppercase mb-1"},[_vm._v("Ventas")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","multiple":"","chips":"","deletable-chips":"","clearable":"","hide-details":"","item-text":"name","item-value":"id","label":"Tipo de Pago para Ventas","items":_vm.typePaymentMethods},on:{"change":function($event){_vm.emitChange('codeSales', $event)}},model:{value:(_vm.typePaymentSales),callback:function ($$v) {_vm.typePaymentSales=$$v},expression:"typePaymentSales"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1048:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_products_vue__ = __webpack_require__(844);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b399435_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_products_vue__ = __webpack_require__(1049);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b399435_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1049:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs7":"","ml-5":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","mr-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","type":"number","label":"Limite de Productos","required":""},model:{value:(_vm.productLimit),callback:function ($$v) {_vm.productLimit=$$v},expression:"productLimit"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_documents_vue__ = __webpack_require__(845);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c77120e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_documents_vue__ = __webpack_require__(1053);
function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c77120e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_documents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c77120e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_documents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("07402f7d", content, true);

/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "span[data-v-0c77120e]{font-size:15px!important}", "", {"version":3,"sources":["/opt/buildhome/repo/src/components/configuration-general/configuration-documents.vue"],"names":[],"mappings":"AACA,sBACC,wBAA2B,CAC3B","file":"configuration-documents.vue","sourcesContent":["\nspan[data-v-0c77120e] {\n\tfont-size: 15px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs7":"","ml-5":"","mt-4":""}},[(_vm.showPurchase)?_c('v-layout',{attrs:{"wrap":""}},[_c('span',{staticClass:"grey--text text--darken-2 caption font-weight-bold uppercase mb-1"},[_vm._v("Compras")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","multiple":"","chips":"","deletable-chips":"","clearable":"","hide-details":"","item-text":"name","item-value":"id","label":"Documentos de Compra","items":_vm.documentTypesPurchases},on:{"change":function($event){_vm.emitChange('codePurchase', $event)}},model:{value:(_vm.codePurchase),callback:function ($$v) {_vm.codePurchase=$$v},expression:"codePurchase"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.showSales)?_c('v-layout',{attrs:{"wrap":""}},[_c('span',{staticClass:"grey--text text--darken-2 caption font-weight-bold uppercase mb-1"},[_vm._v("Ventas")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","multiple":"","chips":"","deletable-chips":"","clearable":"","hide-details":"","item-text":"name","item-value":"id","label":"Documentos de Venta","items":_vm.documentTypesSales},on:{"change":function($event){_vm.emitChange('codeSales', $event)}},model:{value:(_vm.codeSales),callback:function ($$v) {_vm.codeSales=$$v},expression:"codeSales"}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-page',{attrs:{"name":"apps","title":_vm.$route.meta.title}}),_vm._v(" "),_c('section',{staticClass:"main-container"},[_c('div',{staticClass:"item-list-container"},[_c('ul',{staticClass:"item-list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"item"},[_c('button',{staticClass:"item-button",class:{ 'disabled': item.disabled },attrs:{"disabled":item.disabled},on:{"click":function($event){_vm.changeCode(item.code)}}},[_vm._v("\n                            "+_vm._s(item.name)+"\n                        ")])])}))]),_vm._v(" "),_c('div',{staticClass:"additional-component"},[(_vm.modalCode === 'CP')?_c('configuration-subsidiary',{attrs:{"data":_vm.data},on:{"update:subsidiaries":_vm.updateProdSub}}):_vm._e(),_vm._v(" "),(_vm.modalCode === 'PR')?_c('configuration-products',{attrs:{"data":_vm.data},on:{"update:productLimit":_vm.updateProdSub}}):_vm._e(),_vm._v(" "),(_vm.modalCode === 'CE')?_c('configuration-employee',{attrs:{"data":_vm.data},on:{"update:employeeCount":_vm.updateEmployee}}):_vm._e(),_vm._v(" "),(_vm.modalCode === 'KE')?_c('configuration-kardex',{attrs:{"data":_vm.data},on:{"update:flagKardex":_vm.updateParamsGlobal}}):_vm._e(),_vm._v(" "),(_vm.modalCode === 'PG')?_c('configuration-params-globales',{attrs:{"data":_vm.data},on:{"update:flagKardex":_vm.updateParamsGlobal}}):_vm._e(),_vm._v(" "),(_vm.modalCode === 'PM')?_c('configuration-payment-methods',{attrs:{"data":_vm.data},on:{"update-settings":_vm.updateSettings}}):_vm._e(),_vm._v(" "),(_vm.modalCode === 'DP')?_c('configuration-documents',{attrs:{"data":_vm.data,"show-purchase":true,"show-sales":false},on:{"update-settings-documents":_vm.updateSettingsDocuments}}):_vm._e(),_vm._v(" "),(_vm.modalCode === 'DS')?_c('configuration-documents',{attrs:{"data":_vm.data,"show-purchase":false,"show-sales":true},on:{"update-settings-documents":_vm.updateSettingsDocuments}}):_vm._e()],1)]),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"success-text":"Guardar","is-loading":false},on:{"accept-button-clicked":_vm.saveDataGeneral,"cancel-button-clicked":_vm.backList}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_configuration_general_v2_vue__ = __webpack_require__(836);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d42cba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_configuration_general_v2_vue__ = __webpack_require__(1054);
function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44d42cba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_configuration_general_v2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d42cba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_configuration_general_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_configuration_general_configuration_employee__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_configuration_general_configuration_kardex__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_configuration_general_configuration_params_globales__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_configuration_general_configuration_subsidiary__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_configuration_general_configuration_payment_methods__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_configuration_general_configuration_products__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_configuration_general_asign_employee__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_configuration_general_configuration_documents__ = __webpack_require__(1050);



var loadData = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var headers, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        headers = {
                            Accept: '' + 'application/vnd.apiacl.v2+json'
                        };
                        _context.next = 4;
                        return this.$http.get('template/' + this.idTemplate, { headers: headers });

                    case 4:
                        response = _context.sent;

                        this.data = response.data.data;
                        this.settings = this.data.items.data.settings;
                        this.employeeCount = this.data.settings.company && this.data.settings.company.employeeCount || 0;
                        this.domains = this.data.settings && this.data.settings.domains ? this.data.settings.domains : [];
                        this.modalCode = 'CP';
                        _context.next = 16;
                        break;

                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context['catch'](0);

                        console.log(_context.t0);
                        this.showError();

                    case 16:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[0, 12]]);
    }));

    return function loadData() {
        return _ref.apply(this, arguments);
    };
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











function created() {
    var _$route$params = this.$route.params;
    this.codeProject = _$route$params.codeProject;
    this.idTemplate = _$route$params.idTemplate;

    this.loadData();
}

function data() {
    return {
        items: [{ id: 1, name: 'Empleados', code: 'CE' }, { id: 2, name: 'Compañía', code: 'CP' }, { id: 3, name: 'Productos', code: 'PR' }, { id: 4, name: 'Kardex', code: 'KE' }, { id: 5, name: 'Fac. Electrica', code: 'FE', disabled: true }, { id: 6, name: 'Param. Globales', code: 'PG' }, { id: 7, name: 'Medios Pagos', code: 'PM' }, { id: 8, name: 'Doc. Compra', code: 'DP' }, { id: 9, name: 'Doc. Venta', code: 'DS' }],
        action: {
            title: '',
            open: false,
            code: '',
            width: 0
        },
        modalCode: '',
        idTemplate: null,
        codeProject: null,
        subsidiaries: [],
        limitProducts: 0,
        data: {},
        settings: {},
        employeeCount: 0,
        domains: []
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'page-configuration-general',
    created: created,
    data: data,
    components: {
        actionSidebar: __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__["default"],
        configurationSubsidiary: __WEBPACK_IMPORTED_MODULE_6__components_configuration_general_configuration_subsidiary__["a" /* default */],
        asignEmployee: __WEBPACK_IMPORTED_MODULE_9__components_configuration_general_asign_employee__["a" /* default */],
        configurationProducts: __WEBPACK_IMPORTED_MODULE_8__components_configuration_general_configuration_products__["a" /* default */],
        configurationKardex: __WEBPACK_IMPORTED_MODULE_4__components_configuration_general_configuration_kardex__["a" /* default */],
        configurationEmployee: __WEBPACK_IMPORTED_MODULE_3__components_configuration_general_configuration_employee__["a" /* default */],
        configurationPaymentMethods: __WEBPACK_IMPORTED_MODULE_7__components_configuration_general_configuration_payment_methods__["a" /* default */],
        configurationParamsGlobales: __WEBPACK_IMPORTED_MODULE_5__components_configuration_general_configuration_params_globales__["a" /* default */],
        configurationDocuments: __WEBPACK_IMPORTED_MODULE_10__components_configuration_general_configuration_documents__["a" /* default */]
    },
    methods: {
        loadData: loadData,
        changeCode: function changeCode(code) {
            this.modalCode = code;
        },
        updateProdSub: function updateProdSub(newVal, model) {
            if (model === 'limitProducts') {
                this.limitProducts = newVal;
            } else if (model === 'subsidiaries') {
                this.subsidiaries = newVal;
            }
        },
        updateParamsGlobal: function updateParamsGlobal(newVal) {
            this.settings = newVal;
        },
        updateEmployee: function updateEmployee(newVal) {
            this.data.settings.company.employeeCount = Number(newVal);
            this.employeeCount = Number(newVal);
        },
        backList: function backList() {
            this.goTo('page-template');
        },
        calculateTotalQuantity: function calculateTotalQuantity() {
            var totalQuantity = 0;

            this.subsidiaries.forEach(function (subsidiary) {
                subsidiary.warehouse.forEach(function (warehouse) {
                    warehouse.user.forEach(function (user) {
                        totalQuantity += parseInt(user.quantity, 10);
                    });
                });
            });

            return Number(totalQuantity);
        },
        saveDataGeneral: function saveDataGeneral() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var headers, companyNew, body, dataItem, bodySetting;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this.calculateTotalQuantity() > _this.employeeCount)) {
                                    _context2.next = 3;
                                    break;
                                }

                                _this.showError('La cantidad de empleados excede al total de empleados configurados');
                                return _context2.abrupt('return');

                            case 3:
                                headers = {
                                    Accept: '' + 'application/vnd.apiacl.v2+json'
                                };
                                companyNew = {
                                    employeeCount: Number(_this.employeeCount),
                                    subsidiary: _this.subsidiaries,
                                    subsidiaryCount: _this.subsidiaries.length,
                                    productLimit: Number(_this.limitProducts)
                                };
                                body = {
                                    name: _this.data.name,
                                    description: _this.data.description,
                                    settings: {
                                        domains: _this.domains,
                                        company: companyNew
                                    }
                                };
                                dataItem = _this.data.items.data;
                                bodySetting = {
                                    description: dataItem.description,
                                    flagActive: Boolean(dataItem.flagActive),
                                    name: dataItem.name,
                                    settings: _this.settings
                                };
                                _context2.prev = 8;
                                _context2.next = 11;
                                return _this.$http.put('template/' + _this.idTemplate, body, { headers: headers });

                            case 11:
                                _context2.next = 13;
                                return _this.$http.put('project/' + _this.codeProject + '/items/' + dataItem.id, bodySetting);

                            case 13:
                                _this.loadData();
                                _this.backList();
                                _context2.next = 20;
                                break;

                            case 17:
                                _context2.prev = 17;
                                _context2.t0 = _context2['catch'](8);

                                if (_context2.t0.status === 500) {
                                    _this.showError();
                                }

                            case 20:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this, [[8, 17]]);
            }))();
        },
        updateSettings: function updateSettings(_ref2) {
            var key = _ref2.key,
                value = _ref2.value;

            this.settings.typePaymentsInit[key] = value;
            console.log('this.settings', this.settings);
        },
        updateSettingsDocuments: function updateSettingsDocuments(_ref3) {
            var key = _ref3.key,
                value = _ref3.value;

            if (!this.settings.msTypeDocumentInit) {
                this.$set(this.settings, 'msTypeDocumentInit', {});
            }
            this.$set(this.settings.msTypeDocumentInit, key, value);
        }
    }
});

/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
    return {
        employeeCount: 0
    };
}

function created() {
    this.employeeCount = this.data.settings && this.data.settings.company ? this.data.settings.company.employeeCount : 0;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'configuration-products',
    data: data,
    created: created,
    props: {
        data: {
            type: Object
        }
    },
    watch: {
        employeeCount: function employeeCount(newVal) {
            this.$emit('update:employeeCount', newVal, 'employeeCount');
        }
    }
});

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__ = __webpack_require__(150);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function data() {
    return {
        flagKardex: null
    };
}

function created() {
    this.flagKardex = this.data.items.data.settings;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'configuration-kardex',
    data: data,
    components: {
        appTooltipButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__["a" /* default */]
    },
    created: created,
    computed: {
        labelShowKardex: function labelShowKardex() {
            return this.flagKardex.flagKardexValued ? 'Utilizar costo promedio' : 'Utilizar último costo';
        },
        labelShowRegisterKardex: function labelShowRegisterKardex() {
            return this.typeRegisterKardex ? 'Registro inmediato por DB' : 'Registro por SQS';
        }
    },
    props: {
        data: {
            type: Object
        }
    },
    watch: {
        flagKardex: {
            handler: function handler(newVal) {
                this.$emit('update:flagKardex', newVal, 'kardex');
            },

            deep: true
        }
    }
});

/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__ = __webpack_require__(150);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function data() {
	return {
		flagKardex: null,
		selectTypeProducts: [],
		codeComposed: 6,
		codeProduct: 1,
		codeServices: 2,
		tabsModel: null,
		valueTabs: null,
		typeDistanceMode: [{
			id: 1,
			name: 'Lineal'
		}, {
			id: 2,
			name: 'Vehicular'
		}],
		tabs: [{
			id: 1,
			name: 'Productos'
		}, {
			id: 2,
			name: 'Ventas'
		}, {
			id: 3,
			name: 'Cotización'
		}, {
			id: 4,
			name: 'Pedidos'
		}, {
			id: 5,
			name: 'Distribuidor'
		}, {
			id: 6,
			name: 'Contabilidad'
		}, {
			id: 7,
			name: 'Agencia de transporte'
		}, {
			id: 8,
			name: 'Punto de venta'
		}, {
			id: 9,
			name: 'Cliente'
		}, {
			id: 10,
			name: 'Compra'
		}, {
			id: 11,
			name: 'Soporte'
		}],
		flagProducts: [{
			id: 1,
			name: 'Editar código de un producto - (flagCodeProductAuto)',
			tooltip: 'Al activar este switch, se podrá editar el código del proyecto.',
			flag: 'flagCodeProductAuto'
		}, {
			id: 2,
			name: 'Permitir Stock Negativo - (stockNegative)',
			tooltip: 'Cuando realiza ventas que no son inmediatas la empresa puede activar esta opción.',
			flag: 'stockNegative'
		}, {
			id: 3,
			name: 'Descuento global - (globalDiscount)',
			tooltip: 'Si se activa se podrá hacer un descuento  a todos los productos al realizar una venta.',
			flag: 'globalDiscount'
		}, {
			id: 4,
			name: 'Activar precios por categoría (Android) - (flagCategoryPrice)',
			tooltip: 'Actívalo en caso quieras cambiar el precio del producto por el de categoría.',
			flag: 'flagCategoryPrice'
		}, {
			id: 5,
			name: 'Mostrar otros códigos - (flagCodes)',
			tooltip: 'Activar esta opción para tenerla opción de agregar varios códigos a tus productos.',
			flag: 'flagCodes'
		}, {
			id: 6,
			name: 'Mostrar conversiones al crear un producto - (flagConvers)',
			tooltip: 'Activar esta opción cuando se tiene varias presentaciones del producto.',
			flag: 'flagConvers'
		}, {
			id: 7,
			name: 'Mostrar tipo de producto variaciones al crear un producto - (flagShowVariations)',
			tooltip: 'Activar esta opción cuando tienes un producto padre y  productos hijos.',
			flag: 'flagShowVariations'
		}, {
			id: 8,
			name: 'Especificar busqueda lineal o generales el listado de productos - (flagTypeSearch)',
			tooltip: 'Activar esta opción se realizara una busqueda general de lo contraria seria una busqueda especifica.',
			flag: 'flagTypeSearch'
		}, {
			id: 9,
			name: 'Trabajar con Control de Lotes y Fecha de Venc. - (flagWorkWithBatches)',
			tooltip: 'Activar esta opción se realizara trabajar con lotes.',
			flag: 'flagWorkWithBatches'
		}, {
			id: 10,
			name: 'Desea trabajar con IOT - (flagShowIot)',
			tooltip: 'Activar esta opción la compañia trabajara con IOT.',
			flag: 'flagShowIot'
		}, {
			id: 11,
			name: 'Configurar tipo de marca simple - (flagUseSimpleBrand)',
			tooltip: 'Activar esta opción se trabajara con un tipo de marca simple.',
			flag: 'flagUseSimpleBrand'
		}, {
			id: 12,
			name: 'Utilizar el impuesto general del 10% - (flagTaxesIgvTemporary)',
			tooltip: 'Activar esta opción se trabajara con impuesto de 10%.',
			flag: 'flagTaxesIgvTemporary'
		}, {
			id: 13,
			name: 'Permitir generar código automático - (flagCodeAutoGenerate)',
			tooltip: 'Al activar este switch, se podrá generar un código automático al producto.',
			flag: 'flagCodeAutoGenerate'
		}, {
			id: 14,
			name: 'Mostrar solo productos con stock en el POS - (flagHideOutOfStockInPOS)',
			tooltip: 'Al activar esta opción, solo se mostrara los productos con stock en el POS.',
			flag: 'flagHideOutOfStockInPOS'
		}, {
			id: 15,
			name: 'Usar cálculo automático del precio de venta en base al costo - (flagCalculateEarnings)',
			tooltip: 'Si se activa usará el cálculo automático del precio de venta en base al costo mas su ganancia.',
			flag: 'flagCalculateEarnings'
		}, {
			id: 16,
			name: 'Deshabilitar el boton calcular la cantidad en funcion al precio - (priceToQuantityCalculation)',
			tooltip: 'Activar esta opción deshabilitara el boton calcular la cantidad en funcion al precio en el POS',
			flag: 'priceToQuantityCalculation'
		}, {
			id: 17,
			name: 'Sincronizar productos sin stock - (flagProductOnlyStock)',
			tooltip: 'Activar esta opción permitira sincronizar sus productos sin stock',
			flag: 'flagProductOnlyStock'
		}, {
			id: 18,
			name: 'Mostrar opción Inventario Rápido - (flagInventoryFast)',
			tooltip: 'Activar esta opción permitira realizar un inventario rapido',
			flag: 'flagInventoryFast'
		}, {
			id: 19,
			name: 'Trabajar con Producto Express - (flagProductExpressFlow)',
			tooltip: 'Mostrar seleccion y crear un producto rapido (Parecido a un servicio de producto servicio).',
			flag: 'flagProductExpressFlow'
		}, {
			id: 20,
			name: 'Permitir Control de Conversiones - (flagStockByConversion)',
			tooltip: 'Activar esta opción permitira tener referencia de stock por Conversiones',
			flag: 'flagStockByConversion'
		}],
		flagSales: [{
			id: 1,
			name: 'Habilitar Cliente Genérico - (flagGenericSalesCustomer)',
			tooltip: 'Al deshabilitar este campo, no podrá realizar un documento de venta con un cliente genérico.',
			flag: 'flagGenericSalesCustomer'
		}, {
			id: 2,
			name: '',
			tooltip: 'Activar para descargar las ventas en pdf o desactivar para visualizar el reporte y poder imprimirlo.',
			flag: 'downloadSale'
		}, {
			id: 3,
			name: 'Mostrar Opción Recargo al Consumo - (flagTip)',
			tooltip: 'Solo se usa para propinas.',
			flag: 'flagTip'
		}, {
			id: 4,
			name: 'Precio base para cálculo al genera ventas - (flagBasePriceDefault)',
			tooltip: 'Siempre mantener activado.',
			flag: 'flagBasePriceDefault'
		}, {
			id: 5,
			name: 'Total en efectivo por defecto al crear la venta - (showCash)',
			tooltip: 'Si tu cliente usualmente paga en efectivo te aparecerá por defecto seleccionada la opción de efectivo al momento de realizar una venta.',
			flag: 'showCash'
		}, {
			id: 6,
			name: 'Descuento por producto al realizar una venta - (singleDiscount)',
			tooltip: 'Permitir realizar un descuento por producto, al realizar una venta.',
			flag: 'singleDiscount'
		}, {
			id: 7,
			name: 'Mostrar Opción Despachar Productos - (flagTransferDisplay)',
			tooltip: 'Al hablitar este campo, se podra descontar stock al convertir un documento de venta.',
			flag: 'flagTransferDisplay'
		}, {
			id: 8,
			name: 'Autodespacho - (autoDispatch)',
			tooltip: 'Al hablitar este parametro, se habilitara el autodespacho al realizar una venta.',
			flag: 'autoDispatch'
		}, {
			id: 9,
			name: '',
			tooltip: 'Al activar esta opción se realizara descuento en monto, de lo contrario se realizara por porcentaje.',
			flag: 'flagTypeDiscount'
		}, {
			id: 10,
			name: 'Notificar cuando el Precio Venta es menor al Precio Costo - (showNotifySale)',
			tooltip: 'Al activar esta opción se mostrar un mensaje de alerta cuando el precio de venta es mayor al precio de costo.',
			flag: 'showNotifySale'
		}, {
			id: 11,
			name: 'Mostrar imagen en buscar producto - (showImageSearch)',
			tooltip: 'Al activar esta opción se mostrar un mensaje de alerta cuando el precio de costo es mayor al precio de venta.',
			flag: 'showImageSearch'
		}, {
			id: 12,
			name: 'Deshabilitar impresión de ticket en el detalle de venta ( Movil ) - (flagDisablePrintMobile)',
			tooltip: 'Al activar esta opción se deshabilitar impresion de ticket en el detalle de venta movil.',
			flag: 'flagDisablePrintMobile'
		}, {
			id: 13,
			name: 'Habilitar Guia de Remisión Electronica - (flagElectronicGuide)',
			tooltip: 'Al activar esta opción se visualizará las imagenes del producto en la opcion buscar producto.',
			flag: 'flagElectronicGuide'
		}, {
			id: 14,
			name: 'Editar precios durante la venta - (flagUpdatePrice)',
			tooltip: 'Si tienes un punto de venta y desean que sus vendedores editen el precio activar la opción.',
			flag: 'flagUpdatePrice'
		}, {
			id: 15,
			name: 'Usar Lector de barras en ventas - (flagBarcodeReader)',
			tooltip: 'Solo activar esta opción siempre y cuando vendas con código de barra.',
			flag: 'flagBarcodeReader'
		}, {
			id: 16,
			name: 'Asignar empleado a la venta (Android) - (assignEmployee)',
			tooltip: 'Cuando se tenga una sola caja y varios vendedores.',
			flag: 'assignEmployee'
		}, {
			id: 17,
			name: 'Activar Loyalty - (flagLoyalti)',
			tooltip: 'Permitir al realizar un documento de venta, tus clientes cajeen sus puntos.',
			flag: 'flagLoyalti'
		}, {
			id: 18,
			name: 'Activar cambio de precio en móvil con clave de supervisor - (flagEditPriceBySupervisor)',
			tooltip: 'Al activar esta opción se activará el cambio de precio en móvil con la clave del supervisor',
			flag: 'flagEditPriceBySupervisor'
		}, {
			id: 19,
			name: 'Activar anticipos de venta - (flagAdvanceOnSale)',
			tooltip: 'Al activar esta opción se activará los anticipos en ventas.',
			flag: 'flagAdvanceOnSale'
		}, {
			id: 20,
			name: 'Habilitar la configuración de liquidación por producto en ventas - (flagSettlement)',
			tooltip: 'Al activar esta opción se activará la configuracion de liqudacion por producto en ventas.',
			flag: 'flagSettlement'
		}],
		flagQuotations: [{
			id: 1,
			name: 'Mostrar Campos de Importación - (flagImport)',
			tooltip: 'Si en caso se trabaje con cotizaciones y  deseas que los días de demora en importar el producto aparezca en la cotización activar esta opción%.',
			flag: 'flagImport'
		}, {
			id: 2,
			name: 'Configuración para template - (flagQuotation)',
			tooltip: 'Activar esta opción para personalizar tu cotización (Costo Adicional).',
			flag: 'flagQuotation'
		}, {
			id: 3,
			name: 'Reservar stock - (COTMoveKardex)',
			tooltip: 'Activar esta opción si desea activar reservar stock del producto.',
			flag: 'COTMoveKardex'
		}, {
			id: 4,
			name: '',
			tooltip: 'Al activar esta opción solamente se podrá convertir a venta una vez y bloqueara el botón de convertir a venta.',
			flag: 'flagMultipleSalesConversionsQuote'
		}, {
			id: 5,
			name: 'Incluye IGV en cotizaciones - (flagIgv)',
			tooltip: 'El precio de tu productos se va a reflejar si va incluir IGV o no en la cotización.',
			flag: 'flagIgv'
		}],
		flagOrders: [{
			id: 1,
			name: 'Verificar que se muestre el tipo de origen del pedido - (flagTypeOriginOrder)',
			tooltip: 'Este acción te permite la selección de tipo de origenes al pedido.',
			flag: 'flagTypeOriginOrder'
		}, {
			id: 2,
			name: 'Ocultar Unidad funcional si esque existe conversión - (flagShowBaseUnit)',
			tooltip: 'Este acción te permite ocutar la unidad de conversión.',
			flag: 'flagShowBaseUnit'
		}, {
			id: 3,
			name: 'Usar categorías ecommerce recursivas (categorías padres) - (flagCatEcomFather)',
			tooltip: 'En caso utilicen la tienda Virtual activar esta opción.',
			flag: 'flagCatEcomFather'
		}, {
			id: 4,
			name: 'Mostrar campo slug en producto ecommerce - (flagShowSlugProduct)',
			tooltip: 'Si utilizan a tienda virtual activar esta opción.',
			flag: 'flagShowSlugProduct'
		}, {
			id: 5,
			name: 'Dirección no requerida para Vendor. - (flagAddressNotRequired)',
			tooltip: 'Esta opción permite elegir si desea la dirección sea requerida o no.',
			flag: 'flagAddressNotRequired'
		}, {
			id: 6,
			name: 'Compañia Fujo Restaurant - (restaurantFlow)',
			tooltip: 'Esta opcion solo usan las compañias que son restaurants.',
			flag: 'restaurantFlow'
		}, {
			id: 7,
			name: 'Permitir crear pedido como borrador desde Vendor - (flagEditOrderVendor)',
			tooltip: 'Esta opción permite elegir si desea la dirección sea requerida o no.',
			flag: 'flagEditOrderVendor'
		}, {
			id: 8,
			name: 'Generación de documentos no sea automática desde integraciones (SHOPIFY) - (flagNotConvertToSaleFlow)',
			tooltip: 'Esta opción permite generar docoumentos no sean automaticas en shopify.',
			flag: 'flagNotConvertToSaleFlow'
		}, {
			id: 9,
			name: 'Permitir Crear Rutas con pedidos solicitados - (flagEnableRequestedRoutes)',
			tooltip: 'Esta opción permite crear ruta con pedidos solicitados.',
			flag: 'flagEnableRequestedRoutes'
		}, {
			id: 10,
			name: 'Permitir Crear Rutas con pedidos pendientes - (flagEnablePendingRoutes)',
			tooltip: 'Esta opción permite crear ruta con pedidos pendientes.',
			flag: 'flagEnablePendingRoutes'
		}, {
			id: 11,
			name: 'Agregar impuesto por defecto (IGV) - (MOVIL) - (flagTypeOriginOrder)',
			tooltip: 'Indica si se debe mostrar o no el selector de impuestos en pantallas de productos.',
			flag: 'flagTypeOriginOrder'
		}, {
			id: 12,
			name: 'Mostrar solo los productos con stock en la tienda online - (flagHideOutOfStock)',
			tooltip: 'Al activar esta opcion se mostrara solo los productos con stock en la tienda online.',
			flag: 'flagHideOutOfStock'
		}, {
			id: 13,
			name: 'Mostrar total de pedidos en el listado desde el Móvil - (flagShowTotalOrders)',
			tooltip: 'Activar esta opción para mostrar el total de pedidos en el listado.',
			flag: 'flagShowTotalOrders'
		}, {
			id: 14,
			name: 'Activar aprobación del administrador para que el vendedor cambie la lista de precio - (flagPriceListChangeApproval)',
			tooltip: 'Este acción te permite usar la aprobación del administrador para que el vendedor cambie la lista de precio',
			flag: 'flagPriceListChangeApproval'
		}, {
			id: 15,
			name: 'Permitir ingresar el código del vendedor para verificar existencia - (checkSellerWritedCode)',
			tooltip: 'Permitir ingresar el código del vendedor para verificar su existencia; de lo contrario, mostrar un selector de empleados',
			flag: 'checkSellerWritedCode'
		}, {
			id: 16,
			name: 'Tipo de Conversión a venta - (flagTypeConvertToSale)',
			tooltip: 'Al habilitar esta opción los documentos convertidos a ventas seran automático separado por almacén, sino seria una conversión normal (servicio de venta)',
			flag: 'flagTypeConvertToSale'
		}, {
			id: 17,
			name: 'Permitir stock Negativo en Pedidos - (allowOrderStockNegative)',
			tooltip: 'Esta opción permitir stock negativo en pedidos',
			flag: 'allowOrderStockNegative'
		}, {
			id: 18,
			name: 'Permitir editar cliente por rol almacenero - (allowEditCustomerWarehouse)',
			tooltip: 'Esta opción permite editar cliente por rol almacenero',
			flag: 'allowEditCustomerWarehouse'
		}, {
			id: 19,
			name: 'Activar notificaciones al almacenero al confirmar pedido - (flagNotifyStorekeeper)',
			tooltip: 'Esta opción permite notificar al almacenero al confirmar el pedido',
			flag: 'flagNotifyStorekeeper'
		}, {
			id: 20,
			name: 'Esta opción permite no imprimir el pedido - (flagDoNotPrintRequestedOrder)',
			tooltip: 'Esta opción permite no imprimir el pedido',
			flag: 'flagDoNotPrintRequestedOrder'
		}, {
			id: 21,
			name: 'Agregar impuesto por defecto (IGV) - (MOVIL) - (flagTaxesDefault)',
			tooltip: 'Indica si se debe mostrar o no el selector de impuestos en pantallas de productos',
			flag: 'flagTaxesDefault'
		}, {
			id: 22,
			name: 'Solo despachar si el pedido esta convertido a venta - (flagDispatchConvertedOrder)',
			tooltip: 'Permite despachar pedidos convertidos a venta',
			flag: 'flagDispatchConvertedOrder'
		}, {
			id: 23,
			name: 'Permitir asignar empleado al crear pedido - (flagAssignEmployeeOrder)',
			tooltip: 'Esta opción permite asignar empleado al crear pedido',
			flag: 'flagAssignEmployeeOrder'
		}, {
			id: 24,
			name: 'Marcar pedido como confirmado al crear un pedido - (flagDeliveryAsConfirmed)',
			tooltip: 'Esta opción permite marcar como confirmado automáticamente un pedido luego de crearlo',
			flag: 'flagDeliveryAsConfirmed'
		}],
		flaDistributions: [{
			id: 1,
			name: 'Compañía tipo distribuidor - (flagGrouper)',
			tooltip: 'Se podrá activar esta opción solo cuando son compañías tipo distribuidor y se encuentran dentro del plan Mega',
			flag: 'flagGrouper'
		}, {
			id: 2,
			name: 'Cierre automatico de rutas - (flagAutomaticRoutesClose)',
			tooltip: 'Finalizar las rutas de forma masiva.',
			flag: 'flagAutomaticRoutesClose'
		}],
		flagAccounting: [{
			id: 1,
			name: 'Tipo de Integración General - (flagTypeIntegrationGrouper)',
			tooltip: 'Activar en caso se quiera participar en el plan Beta del Modo de contabilidad que se esta lanzando en modo prueba',
			flag: 'flagTypeIntegrationGrouper'
		}, {
			id: 2,
			name: 'Contabilidad - (flagShowAccountingEngine)',
			tooltip: 'Activar en caso se quiera participar en el plan Beta del Modo de contabilidad que se esta lanzando en modo prueba.',
			flag: 'flagShowAccountingEngine'
		}],
		flagAgencyTranport: [{
			id: 1,
			name: 'Trabajar con Agencia de transportes - (flagUseTransportAgency)',
			tooltip: 'Permitir enviar tu pedido mediante un agencia de transporte',
			flag: 'flagUseTransportAgency'
		}, {
			id: 2,
			name: 'Pedir Ubigeo en nueva dirección (App de Pedidos) - (flagRequestLocationOrderApp)',
			tooltip: 'Permitir una dirección exacta al realizar un pedido.',
			flag: 'flagRequestLocationOrderApp'
		}, {
			id: 3,
			name: 'Pedir Ubigeo en nueva dirección (App de Vendedor de Campo) - (flagAskLocationSellerApp)',
			tooltip: 'Permitir una dirección exacta al realizar un pedido.',
			flag: 'flagAskLocationSellerApp'
		}, {
			id: 4,
			name: 'Registrar vehículos y conductores del transportista - (flagRelateVehicleFloat)',
			tooltip: 'Indicador para registrar vehículos y conductores del transportista',
			flag: 'flagRelateVehicleFloat'
		}],
		flagPointSale: [{
			id: 1,
			name: 'Alertar en el punto de venta móvil que un producto posee conversiones - (flagAlertConversions)',
			tooltip: 'Permitir una dirección exacta al realizar un pedido',
			flag: 'flagAlertConversions'
		}],
		flagCustomers: [{
			id: 1,
			name: 'Habilitar email obligatorio al crear cliente - (emailCustomerMandatory)',
			tooltip: 'Al crear un cliente en configuración si en caso quieras registrar a todos tus clientes con correo activa esta opción.',
			flag: 'emailCustomerMandatory'
		}, {
			id: 2,
			name: 'Usar el servicio de consulta de Numero de documento - (flagUseDocConsulting)',
			tooltip: 'Si esta activo, usara el servicio de consulta de Documento(Cliente y Proveedor).',
			flag: 'flagUseDocConsulting'
		}, {
			id: 3,
			name: 'Permitir que se muestren solo clientes asignados a una determinada ruta - (flagShowCustomersAssignedToRoute)',
			tooltip: 'Si esta activo, solo se mostraran clientes asignados a una determinada ruta.',
			flag: 'flagShowCustomersAssignedToRoute'
		}],
		flagPurchases: [{
			id: 1,
			name: 'Trabajar con Percepción - (flagPerception)',
			tooltip: 'Al activar esta opción, muestra configuración de proveedores con percepcion',
			flag: 'flagPerception'
		}, {
			id: 2,
			name: 'Limitar conversion de ordenes de compra a cantidad relacionada - (flagNotLimitInORC)',
			tooltip: 'Al activar esta opción, se limitara la conversion de ordenes de compra a cantidad relacionada',
			flag: 'flagNotLimitInORC'
		}],
		flagSupport: [{
			id: 1,
			name: 'Esta compañía sera de prueba - (flagTest)',
			tooltip: 'si esta actvo, significa que la cuenta es de prueba',
			flag: 'flagTest'
		}, {
			id: 2,
			name: 'Habilitar el flujo de eliminación de compañía - (flagCompanyEliminated)',
			tooltip: 'Se usaran compañías que pasarán por un flujo de eliminación',
			flag: 'flagCompanyEliminated'
		}, {
			id: 3,
			name: 'Habilita el registro de asistencia desde móvil - (flagAttendanceRegistration)',
			tooltip: 'Habilitar registro de asistencia desde móvil y controlar consumo de servicios asociados',
			flag: 'flagAttendanceRegistration'
		}, {
			id: 4,
			name: 'Activar cuenta del acl - (flagEditBlockedAcl)',
			tooltip: 'Al habilitar esta opcion, permite activar la cuenta del ACL',
			flag: 'flagEditBlockedAcl'
		}, {
			id: 5,
			name: 'Ejecuta cron de actualizacion de Deudas de Clientes - (balanceCustomerAll)',
			tooltip: 'Al habilitar esta opcion, se ejecutara cron de actualizacion de Deudas de Clientes',
			flag: 'balanceCustomerAll'
		}, {
			id: 6,
			name: 'Ocultar campos del ubigeo de las tiendas - (flagNotUseGlobalUbigeo)',
			tooltip: 'Ocultar campos del ubigeo de las tiendas, menos el campo direccion',
			flag: 'flagNotUseGlobalUbigeo'
		}, {
			id: 7,
			name: 'Generar documentos de venta al contado - (flagSalDocAsCash)',
			tooltip: 'Al activar esta opción, los documentos de venta se crearan con metodo de pago al contado',
			flag: 'flagSalDocAsCash'
		}, {
			id: 8,
			name: 'Limitaciones en la Firma Móvil para Cobros y Pagos - (flagDisabledSignature)',
			tooltip: 'Al activar esta opción, no permitira agregar firma en movil al momento de hacer cobros/pagos',
			flag: 'flagDisabledSignature'
		}, {
			id: 9,
			name: 'Generar y Guardar Ticket en PDF - (flagDownloadOrder)',
			tooltip: 'Permite generar y guardar el pdf un ticket de pdf',
			flag: 'flagDownloadOrder'
		}, {
			id: 10,
			name: 'Permitir editar el código externo de una venta en el listado - (flagExternalData)',
			tooltip: 'Permitir editar el código externo de una venta en el listado',
			flag: 'flagExternalData'
		}, {
			id: 11,
			name: 'Indica que se verifica stock negativo de productos agrupados en backend - (flagStockProductGroup)',
			tooltip: 'Al activar esta opción verifica stock negativo de productos agrupados en backend',
			flag: 'flagStockProductGroup'
		}, {
			id: 12,
			name: 'Permite realizar intercambio de puntos por producto - (flagExchangePointsByProduct)',
			tooltip: 'Al activar esta opción se podra intercambiar puntos por producto',
			flag: 'flagExchangePointsByProduct'
		}, {
			id: 13,
			name: 'Permitir muestra lista de sincronizacion de productos maestros - (wholesaler)',
			tooltip: 'Al activar esta opción permitir mostrar lista de sincronización de productos maestros',
			flag: 'wholesaler'
		}, {
			id: 14,
			name: 'Trabajar con Producto Fabricado - (flagFlowManufacturedProduct)',
			tooltip: 'Permitir Mostrar tipo de producto Insumo y crer tipo manufacturado como terminado.',
			flag: 'flagFlowManufacturedProduct'
		}, {
			id: 15,
			name: 'Permitir registros para sincronización de stock de productos - (flagSyncMoveTypeFirebase)',
			tooltip: 'Permitir registros para sincronización de stock de productos',
			flag: 'flagSyncMoveTypeFirebase'
		}, {
			id: 16,
			name: 'Indicar si la empresa trabajara con conversion (intercambio de documento NTV -> BOL) - (flagChangeNtvFlow)',
			tooltip: 'Permitir intercambiar numeracion al convertir notas de venta(relacionadas a pedidos) a boleta/factura.',
			flag: 'flagChangeNtvFlow'
		}, {
			id: 17,
			name: 'Configuracion temporal para trabajar con la nueva estructura de kardex - (flagNewKardexV3)',
			tooltip: 'Configuracion temporal para pruebas que trabjan con la nueva estructura de kardex',
			flag: 'flagNewKardexV3'
		}, {
			id: 18,
			name: 'Indica ingreso directo a tablas de productos maestro/almacen - (flagNotMoveKardex)',
			tooltip: 'Indica ingreso directo a tablas de productos maestro/almacen. En caso este desactivado se manejará el registro de stock en Kardex',
			flag: 'flagNotMoveKardex'
		}, {
			id: 19,
			name: 'Utilizar costo promedio / Utilizar último costo (Dinámico) - (flagKardexValued)',
			tooltip: 'Si activo esta opción se usará el calculo de costo promedio si en caso lo desactivo el costo que se va a mostrar en tu producto maestro va hacer el último costo de tu compra.',
			flag: 'flagKardexValued'
		}, {
			id: 20,
			name: 'Calculo de saldo de stock y costo inmediato - (flagKardexFast)',
			tooltip: 'Indica si el inmediatamente despues de registrar en el kardex estos registros se les calculará el stock y/o costo',
			flag: 'flagKardexFast'
		}, {
			id: 21,
			name: 'Registro inmediato por DB / Registro por SQS (Dinámico) - (typeRegisterKardex)',
			tooltip: 'Al habilitar este campo se genera un registro inmediato por DB, de lo contrario se registra por SQS',
			flag: 'typeRegisterKardex'
		}, {
			id: 22,
			name: 'Permitir realizar solicitudes aprobadas por defecto y recepcionar transferencias - (flagImmediateTransfer)',
			tooltip: 'Permitir realizar solicitudes aprobadas por defecto y recepcionar transferencias no aceptados por el un administrador',
			flag: 'flagImmediateTransfer'
		}, {
			id: 23,
			name: 'Incluir código de impuesto por defecto - (codeDefaultTaxes)',
			tooltip: 'Incluir código de impuesto por defecto',
			flag: 'codeDefaultTaxes'
		}, {
			id: 24,
			name: 'Permite visualizar el historial de cambios del precio los productos en el punto de venta - (flagAuditService)',
			tooltip: 'Permite visualizar el historial de cambios del precio los productos en el punto de venta',
			flag: 'flagAuditService'
		}, {
			id: 25,
			name: 'Habilitar redondeo de ventas - (flagRoundSales)',
			tooltip: 'Habilitar redondeo de ventas.',
			flag: 'flagRoundSales'
		}, {
			id: 26,
			name: 'Indicar si las compras tendran ingreso a caja - (flagPurCashDeskClosing)',
			tooltip: 'Indicar si las compras tendran ingreso a caja',
			flag: 'flagPurCashDeskClosing'
		}, {
			id: 27,
			name: 'Autogenerar Series de Compras - (flagPurAutoGenerateSerie)',
			tooltip: 'Indicar que los tipos de documentos de compra con flagGenerateSerie crearan serie por defecto.',
			flag: 'flagPurAutoGenerateSerie'
		}, {
			id: 28,
			name: 'Notificacion por topic a movil al convertir pedido a venta - (flagNotifySalesConversion)',
			tooltip: 'Envia notificacion por topic a movil al convertir pedido a venta.',
			flag: 'flagNotifySalesConversion'
		}, {
			id: 29,
			name: 'Habilitar recurso de anexo de caja (POS) - (flagAnnexTransactions)',
			tooltip: 'Habilitar recurso de anexo de caja (POS)',
			flag: 'flagAnnexTransactions'
		}]
	};
}

function created() {
	var settings = this.data.items.data.settings;
	this.flagKardex = settings;
	this.selectTypeProducts = settings.typeProductsCreationPermission || [];
	this.flagSales[1].name = settings.downloadSale ? 'Descargar Documento' : 'Vista Previa del Documento';
	this.flagSales[8].name = settings.flagTypeDiscount ? 'Descuento por monto - (flagTypeDiscount)' : 'Descuento por porcentaje - (flagTypeDiscount)';
	this.flagQuotations[3].name = settings.flagMultipleSalesConversionsQuote ? 'Permitir realizar solamente una conversión a venta - (flagMultipleSalesConversionsQuote)' : 'Permitir realizar multiples conversiones a venta - (flagMultipleSalesConversionsQuote)';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'configuration-params-globales',
	data: data,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__["a" /* default */]
	},
	created: created,
	computed: {
		labelShowKardex: function labelShowKardex() {
			return this.flagKardex.flagKardexValued ? 'Utilizar costo promedio' : 'Utilizar último costo';
		},
		labelShowRegisterKardex: function labelShowRegisterKardex() {
			return this.typeRegisterKardex ? 'Registro inmediato por DB' : 'Registro por SQS';
		}
	},
	props: {
		data: {
			type: Object
		}
	},
	watch: {
		tabsModel: function tabsModel(value) {
			this.valueTabs = value;
		},

		flagKardex: {
			handler: function handler(newVal) {
				this.$emit('update:flagKardex', newVal, 'paramsGlobal');
			},

			deep: true
		}
	}
});

/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_configuration_general_asign_employee__ = __webpack_require__(841);



var loadData = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (this.data.settings) {
                            this.subsidiaries = this.data.settings && this.data.settings.company ? this.data.settings.company.subsidiary : [];
                            this.countSubsidiary = this.subsidiaries.length;
                        }

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loadData() {
        return _ref.apply(this, arguments);
    };
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function data() {
    return {
        subsidiaries: [],
        loading: false,
        countSubsidiary: null,
        isEdit: false,
        countWarehouse: 0,
        model: {
            codeProject: '',
            description: '',
            name: ''
        },
        action: {
            title: '',
            open: false,
            code: '',
            width: 0
        },
        indexSubs: null,
        indexWarehouse: null,
        users: [],
        isEditWarehouse: false
    };
}

function closeModal() {
    this.action = {
        title: '',
        open: false,
        code: '',
        width: 0
    };
}

function created() {
    var _$route$params = this.$route.params;
    this.codeProject = _$route$params.codeProject;
    this.idTemplate = _$route$params.idTemplate;

    if (this.data) {
        this.loadData();
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'configuration-subsidiary',
    data: data,
    components: {
        actionSidebar: __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__["default"],
        asignEmployee: __WEBPACK_IMPORTED_MODULE_3__components_configuration_general_asign_employee__["a" /* default */]
    },
    created: created,
    methods: {
        loadData: loadData,
        addSubsidiary: function addSubsidiary() {
            var currentLength = this.subsidiaries.length;
            this.subsidiaries.push({
                subsidiaryName: 'Sucursal ' + (currentLength + 1),
                uid: 'SUB0' + (currentLength + 1),
                storeCount: 0,
                warehouse: []
            });
        },
        removeSubsidiary: function removeSubsidiary() {
            if (this.subsidiaries.length > 0) {
                this.subsidiaries.pop();
            }
        },
        addWarehouse: function addWarehouse(index) {
            if (index >= 0 && index < this.subsidiaries.length) {
                var sub = this.subsidiaries[index];
                var currentLength = sub.warehouse.length;

                sub.warehouse.push({
                    uid: 'WAR0' + (currentLength + 1),
                    warehouseName: 'Tienda ' + (currentLength + 1),
                    user: [],
                    suffixDomain: ''
                });
                sub.storeCount = sub.warehouse.length;
            }
        },
        removeWarehouse: function removeWarehouse(index) {
            if (index >= 0 && index < this.subsidiaries.length) {
                var sub = this.subsidiaries[index];
                if (sub.warehouse.length > 0) {
                    sub.warehouse.pop();
                    sub.storeCount = sub.warehouse.length;
                }
            }
        },
        asignEmployee: function asignEmployee(indexSubs, indexWarehouse) {
            this.action.open = true;
            this.action.code = 'AE';
            this.action.title = 'Asignar Empleados';
            this.action.width = 800;
            this.users = [];
            if (this.subsidiaries[indexSubs].warehouse[indexWarehouse].user.length > 0) {
                this.users = this.subsidiaries[indexSubs].warehouse[indexWarehouse].user;
            }
            this.indexSubs = indexSubs;
            this.indexWarehouse = indexWarehouse;
        },
        saveUsers: function saveUsers(user) {
            this.subsidiaries[this.indexSubs].warehouse[this.indexWarehouse].user = user;
            this.users = [];
            this.closeModal();
        },
        editSubsidiary: function editSubsidiary() {
            this.isEdit = !this.isEdit;
        },
        editWarehouse: function editWarehouse() {
            this.isEditWarehouse = !this.isEditWarehouse;
        },

        closeModal: closeModal,
        validateUser: function validateUser(user) {
            var quantity = user.reduce(function (acc, us) {
                return acc + us.quantity;
            }, 0);
            return quantity;
        }
    },
    props: {
        data: {
            type: Object
        }
    },
    watch: {
        subsidiaries: {
            handler: function handler(newVal) {
                this.$emit('update:subsidiaries', newVal, 'subsidiaries');
            },

            deep: true
        }
    }
});

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asign_employee_vue__ = __webpack_require__(842);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e6bed9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asign_employee_vue__ = __webpack_require__(1042);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asign_employee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e6bed9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asign_employee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_tooltip_button__ = __webpack_require__(150);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function data() {
    return {
        countEmployee: 0,
        users: [],
        roles: [],
        model: {
            role: null,
            quantity: 0,
            name: '',
            typeDocuments: [],
            serieInit: 1,
            employeeInit: 1,
            flagNotShowCostPrice: false
        },
        typeDocuments: [{ id: 1, name: 'COTIZACION', code: 'COT' }, { id: 2, name: 'FACTURA', code: 'FAC' }, { id: 3, name: 'BOLETA', code: 'BOL' }, { id: 4, name: 'NOTA DE VENTA', code: 'NTV' }, { id: 5, name: 'PEDIDO', code: 'PED' }],
        columns: [{ id: 1, name: 'Cantidad', checked: true, visible: true }, { id: 2, name: 'Rol', checked: true, visible: true }, { id: 3, name: 'Nombre', checked: true, visible: true }, { id: 4, name: 'Contraseña', checked: true, visible: true }, { id: 5, name: 'Acción', checked: true, visible: true }]
    };
}

function created() {
    if (this.usersExist.length > 0) {
        this.users = this.usersExist;
    }
    this.loadRoles();
}

function validation() {
    return !this.users.length >= 1;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'asign-employee',
    created: created,
    data: data,
    computed: {
        validation: validation
    },
    components: {
        appTooltipButton: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_tooltip_button__["a" /* default */]
    },
    methods: {
        addEmployee: function addEmployee() {
            var newEmployee = {
                role: this.model.role,
                quantity: Number(this.model.quantity),
                name: this.model.name,
                typeDocuments: this.model.typeDocuments,
                serieInit: Number(this.model.serieInit),
                employeeInit: Number(this.model.employeeInit),
                flagNotShowCostPrice: this.model.flagNotShowCostPrice,
                codeTypeRol: this.model.role.code,
                uid: 'EMP0' + (this.users.length + 1),
                password: 252525,
                flagAdmin: Boolean(this.model.role.isAdmin),
                flagTypePerson: 1,
                flagTerminal: false
            };
            this.users.push(newEmployee);
            this.cleanModel();
        },
        cleanModel: function cleanModel() {
            this.model = {
                role: null,
                quantity: 0,
                name: '',
                typeDocuments: []
            };
        },
        loadRoles: function loadRoles() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var headers, url, _ref, response;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                headers = {
                                    Accept: '' + 'application/vnd.apiacl.v2+json'
                                };
                                url = '/project/' + _this.codeProject + '/template/' + _this.idTemplate + '/roles';
                                _context.next = 4;
                                return _this.$http.get(url, { headers: headers, params: _this.params });

                            case 4:
                                _ref = _context.sent;
                                response = _ref.data;

                                _this.roles = response.data;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        saveData: function saveData() {
            this.users = this.users.map(function (user) {
                var role = user.role,
                    rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(user, ['role']);

                return rest;
            });
            this.$emit('save-data', this.users);
            // this.usersExist = [];
        },
        deleteEmployee: function deleteEmployee(row) {
            this.users = this.users.filter(function (user) {
                return user.id !== row.id;
            });
        }
    },
    props: {
        idTemplate: {
            type: Number
        },
        codeProject: {
            type: String
        },
        usersExist: {
            type: Array
        }
    }
});

/***/ }),

/***/ 843:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'configuration-payment-methods',
	props: {
		data: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	data: function data() {
		return {
			typePaymentPurchases: [],
			typePaymentSales: [],
			typePaymentMethods: [{ id: 'efectivo', name: 'Efectivo' }, { id: 'deposito-bancario', name: 'Depósito Bancario' }, { id: 'yape', name: 'Yape' }, { id: 'plin', name: 'Plin' }, { id: 'niubiz', name: 'Niubiz' }, { id: 'izipay', name: 'Izipay' }, { id: 'vendemas', name: 'Vendemas' }]
		};
	},
	created: function created() {
		if (this.data && this.data.items.data.settings) {
			this.typePaymentPurchases = this.data.items.data.settings.typePaymentsInit.codePurchase || [];
			this.typePaymentSales = this.data.items.data.settings.typePaymentsInit.codeSales || [];
		}
	},

	methods: {
		emitChange: function emitChange(key, value) {
			this.$emit('update-settings', { key: key, value: value });
		}
	},
	watch: {
		data: {
			handler: function handler(newVal) {
				if (newVal && newVal.items && newVal.items.data && newVal.items.data.settings && newVal.items.data.settings.typePaymentsInit) {
					var settings = newVal.items.data.settings.typePaymentsInit;
					var newPurchases = settings.codePurchase || [];
					var newSales = settings.codeSales || [];

					if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.typePaymentPurchases) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newPurchases)) {
						this.typePaymentPurchases = newPurchases;
					}
					if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.typePaymentSales) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newSales)) {
						this.typePaymentSales = newSales;
					}
				}
			},

			deep: true
		}
	}
});

/***/ }),

/***/ 844:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
    return {
        productLimit: 0
    };
}

function created() {
    this.productLimit = this.data.settings && this.data.settings.company ? this.data.settings.company.productLimit : 0;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'configuration-products',
    data: data,
    created: created,
    props: {
        data: {
            type: Object
        }
    },
    watch: {
        productLimit: function productLimit(newVal) {
            this.$emit('update:productLimit', newVal, 'limitProducts');
        }
    }
});

/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'configuration-documents',
	props: {
		data: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		showPurchase: {
			type: Boolean,
			default: true
		},
		showSales: {
			type: Boolean,
			default: true
		}
	},
	data: function data() {
		return {
			flagType: true,
			codePurchase: [],
			codeSales: [],
			documentTypesSales: [{ id: 'FAC', name: 'Factura' }, { id: 'BOL', name: 'Boleta' }, { id: 'NTV', name: 'Nota de Venta' }, { id: 'COT', name: 'Cotización' }, { id: 'PED', name: 'Pedido' }, { id: 'NDC', name: 'Nota de Crédito' }, { id: 'NDD', name: 'Nota de Débito' }, { id: 'GRM', name: 'Guía de Remisión' }],
			documentTypesPurchases: [{ id: 'ORC', name: 'Orden de Compra' }, { id: 'FAC', name: 'Factura' }, { id: 'BOL', name: 'Boleta' }, { id: 'NDC', name: 'Nota de Crédito' }, { id: 'GRM', name: 'Guía de Remisión' }]
		};
	},
	created: function created() {
		if (this.data && this.data.items && this.data.items.data && this.data.items.data.settings && this.data.items.data.settings.msTypeDocumentInit) {
			var settings = this.data.items.data.settings.msTypeDocumentInit;
			this.flagType = settings.flagType !== undefined ? settings.flagType : true;
			this.codePurchase = settings.codePurchase || [];
			this.codeSales = settings.codeSales || [];
		}
	},

	methods: {
		emitChange: function emitChange(key, value) {
			this.$emit('update-settings-documents', { key: key, value: value });
		}
	},
	watch: {
		data: {
			handler: function handler(newVal) {
				if (newVal && newVal.items && newVal.items.data && newVal.items.data.settings && newVal.items.data.settings.msTypeDocumentInit) {
					var settings = newVal.items.data.settings.msTypeDocumentInit;
					this.flagType = settings.flagType !== undefined ? settings.flagType : true;
					var newPurchases = settings.codePurchase || [];
					var newSales = settings.codeSales || [];

					if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.codePurchase) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newPurchases)) {
						this.codePurchase = newPurchases;
					}
					if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.codeSales) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newSales)) {
						this.codeSales = newSales;
					}
				}
			},

			deep: true
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.49e83886f99a58ef8683.js